import { getVideoCdn } from "./video-cdn.js";

/**
 * The marketing gameplay montage (TEX-2238). Web-optimized, muted derivatives
 * produced by scripts/transcode-montage.sh and published to the CloudFront video
 * bucket under the `marketing/` prefix by `pnpm montage:upload`.
 */

/** Committed poster frame — ships in the portal build, served same-origin. */
export const MONTAGE_POSTER = "/marketing/montage-v5-poster.jpg";

/** Clip keys (resolved through {@link montageUrl}). */
export const MONTAGE_DESKTOP = "montage-v5-desktop.mp4"; // 1920×1080
export const MONTAGE_MOBILE = "montage-v5-mobile.mp4"; // 1280×720

export const MONTAGE_ALT =
  "Gameplay reel of Sports Academy Games — kids answering math questions inside arcade games";

/**
 * Resolve a montage clip to its URL. With VITE_VIDEO_CDN set (prod, or a
 * configured dev env) this is the absolute CloudFront URL the <Video> component
 * uses verbatim; unset it falls back to a root-relative `/marketing/<file>` path
 * that resolves on every route. The .mp4s are gitignored, so the same-origin
 * fallback only works when the clip is present on disk (after a local transcode)
 * — otherwise the CDN is the source of truth.
 */
export function montageUrl(file: string): string {
  const cdn = getVideoCdn();
  return cdn ? `${cdn}/marketing/${file}` : `/marketing/${file}`;
}
